import React, { useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  required,
  useCreate,
  useNotify,
  useRedirect,
} from 'react-admin';
import { uploadImage } from '../../../config/services/strapi/strapi';

function ImagenesInicioCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSubmit = async(data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      if (!token) {
        notify('No se encontró el token de autenticación', { type: 'error' });
        return;
      }

      const payload: Record<string, any> = {
        descripcion: data.descripcion,
        nombre: data.nombre,
        texto_destacado: data.texto_destacado,
      };

      if (data.imagen.rawFile) {
        const imageResult = await uploadImage(data.imagen.rawFile, token);
        payload.imagen = imageResult;

        delete payload.imagen.documentId;
      }

      create('imagenes-inicios', { data: payload }, {
        onSuccess: () => {
          notify('Imagen de inicio creada correctamente');
          redirect('list', 'imagenes-inicios');
        },
        onError: (error: any) => {
          notify(`Error al crear la imagen de inicio: ${error.message}`, { type: 'error' });
        },
      });
    }
    catch (error) {
      console.error('Error creando imagen de inicio:', error);
      notify('No se pudo crear la imagen de inicio', { type: 'error' });
    }
  }

  useEffect(() => {
    document.title = 'Crear Imagen de Inicio';
  }, []);

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput source="nombre" validate={[required()]} />
        <TextInput source="texto_destacado" validate={[required()]} />
        <TextInput source="descripcion" validate={[required()]} />
        <FileInput
          source='imagen'
          label='Imagen'
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default ImagenesInicioCreate;